export default __webpack_public_path__ + "static/media/gallery_07.27a0f3a4.jpg";